var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScrollToTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "scroll-to-top_svg__scroll-to-top-icon",
  viewBox: "0 0 24 69"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.5 9h1v60h-1z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "m12 2 10 13H2z"
}))));
export default SvgScrollToTop;